module.exports = __webpack_public_path__ + "1d6ba96dd361b344208fdbb97df871d4.svg";